import type { AuditLogEntry, AuditLogQueryParams } from '../../types/audit.types';
import { apiClient } from '../api-client';
import type { PaginatedItems } from '../api-client';

/**
 * Fetch audit logs for a specific project
 */
export const getProjectAuditLogs = async (
  projectId: string,
  params: AuditLogQueryParams = {}
): Promise<PaginatedItems<AuditLogEntry>> => {
  const url = `/projects/${projectId}/audit-logs`;

  return apiClient.getPaginated<AuditLogEntry>(url, {
    page: params.page,
    limit: params.limit,
    sortBy: params.sortBy,
    sortOrder: params.sortOrder,
  });
};
